import { NgModule } from '@angular/core';
import { TranslateOrderPipe } from './translate-order.pipe';

@NgModule({
    declarations: [TranslateOrderPipe],
    exports: [TranslateOrderPipe]
})
export class TranslateOrderModule {}
